import axios from '@/lib/axios';
import { PurchaseOrderContractTask, PurchaseOrderMember } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0830. 発注案件契約タスクフェーズ更新（次へ）
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_contract_tasks/:id/move_to_next_phase
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
  current_purchase_order_contract_task_phase_id: number;
};

const movePurchaseOrderContractTaskPhaseToNext = (props: Props): Promise<PurchaseOrderContractTask> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/purchase_order_contract_tasks/${props.task_id}/move_to_next_phase`,
    props
  );
};

export const useMovePurchaseOrderContractTaskPhaseToNext = () => {
  return useMutation({
    mutationFn: movePurchaseOrderContractTaskPhaseToNext,
  });
};
